import Card from "../components/Card";
import Image from "../components/Image";

function StatsLower() {
  return (
    <>
      <div
        className=" w-[39%] h-full"
        style={{ transformStyle: "preserve-3d" }}
      >
        <Card
          borderRadius="rounded-2xl"
          innerContent={
            <Image
              containerCss={"w-full h-full"}
              imgCss={"w-full h-full object-fit"}
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1648300135/passage/passage-showcase/country-min_yg0nkz.png"
              }
            />
          }
        />
      </div>
      <div
        className=" w-[60%] h-full"
        style={{ transformStyle: "preserve-3d" }}
      >
        <Card
          borderRadius="rounded-2xl"
          innerContent={
            <Image
              containerCss={"w-full h-full"}
              imgCss={"w-full h-full object-contain"}
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1648301684/passage/passage-showcase/red_kzhvay.png"
              }
            />
          }
        />
      </div>
    </>
  );
}

export default StatsLower;
